'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import WebappServices from '@/components/technologies/webapp-services';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Leading Custom Web Application Development Company Offering Fully-Optimized Solutions Globally!"
                alt="Web Application Development"
                title="Web Application Development"
                width={1137}
                height={825}
                path={'webapp-hero'}
                bgPath={'hero-bg-grunge'}
            >
                Web Application <div>Development Company</div>
            </TechHero>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Web Application" />
            <ContetVideoSection title="Expand Your Business Horizons to Online Space with Our Web App Development Services">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        It’s not just a website; we create seamless and intuitive user experience that keeps coming back and
                        forth. Being recognized in leading research firms like Clutch.co and AppFutura, we specialize in creating
                        user-centric and custom website application development with an innovative approach backed by the latest
                        tools and technologies.
                    </p>
                    <p className="fw-400 text-secondary fs-md  mb-0">
                        Be it a startup, business or enterprise, our strategy is to understand in-depth about user interaction
                        with the product and to prepare a strategy that maximizes user engagement and satisfaction. With over 15+
                        years of experience in offering website application development services globally, our portfolio bag
                        consists of 650+ projects spanning multiple industries and domains including e-commerce, healthcare,
                        travel, automotive, education, media and entertainment and a lot more.
                    </p>
                </>
            </ContetVideoSection>
            <WebappServices></WebappServices>
            <HireProcess
                bg="bg-webapp"
                pageTitle="Hire Web App Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using Web App."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For Web App Development? " />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best Web App Developers"
                desc="Select from different engagement models to hire Web App Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
